/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function TransformTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    ModalService: JS5Object,
    TransformTemplatesService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {
    };
    const getData = () => {
        this.loadingIndicator.show = true;
        TransformTemplatesService.getTransformTemplate($routeParams.id).then((transformTemplate: JS5Object) => {
            TransformTemplatesService.originalEditData = _.cloneDeep(transformTemplate);
            this.editData = transformTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewTransformTemplate();
        }
        else {
            updateTransformTemplate();
        }
    };

    const updateTransformTemplate = () => {
        TransformTemplatesService.updateTransformTemplate(this.editData).then((transformTemplate: JS5Object) => {
            TransformTemplatesService.originalEditData = _.cloneDeep(transformTemplate);
            this.editData = transformTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewTransformTemplate = () => {
        TransformTemplatesService.createTransformTemplate(this.editData).then((transformTemplate: JS5Object) => {
            $route.updateParams({id: transformTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') && _.size(_.get(this.editData, 'name')),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(TransformTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({tab: 'TransformTemplates'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = TransformTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Transform Template',
                        location: '/system/templates/search',
                        params: {tab: 'TransformTemplates'}
                    });
                }
                getData();
            } else {
                TransformTemplatesService.originalEditData = _.cloneDeep(this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Transform Template',
                    location: '/system/templates/search',
                    params: {tab: 'TransformTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        TransformTemplatesService.originalEditData = null;
        TransformTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            TransformTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = TransformTemplatesService;
        });
    };
}


angular.module('prism-ui.transformTemplate').component('transformTemplatesEditView', {
    templateUrl: 'system/templates/transformTemplate/editor/transform-template-editor-template.html',
    controller: TransformTemplatesEditViewController,
    bindings: {
    }
});
